<template>
  <div :class="['container', 'banner-wrapper', `${page_style}`]">
    <p class="title" :style="{fontSize: formItem.font_size}" v-if="formItem.title">{{formItem.title}}</p>
    <p class="desc" v-if="formItem.desc">{{formItem.desc}}</p>
  </div>
</template>
<script>
export default {
  props: ["formItem", "page_style"],
  mounted() {}
};
</script>
<style lang="scss" scoped>
.h5_funnel_fleet.banner-wrapper {
  padding: 0 0.32rem 0.22rem 0.32rem;
}
.title {
  padding-top: 0.32rem;
  font-size: 0.4rem;
  font-weight: 900;
  color: #333;
  padding-bottom: .1rem;
}
.desc {
  padding: 0.112rem 0 0.16rem 0;
  font-size: 0.28rem;
  color: #7e7e80;
}
.h5_funnel_fleet_pc {
  .banner-wrapper {
    padding: 0 32px 32px 32px;
  }
  .title {
    padding: 64px 0 0 0;
    font-size: 28px !important; //暂时加important覆盖
    font-weight: 700;
  }
  .desc {
    padding: 5px 0 8px 0;
    font-size: 14px;
    color: #7e7e80;
  }
}
</style>


